/**
 * 取得靜態檔 url
 * @param path 圖片path, ex: 'assets/images/xxx.webp'
 * @returns url string
 */
import { uris } from '../../config/environment';

export default function getUrl(path: string) {
    return new URL(`${path}`, uris.BASE_URL).href;
}
